const global = window

// Remplissage automatique
inputs.behavior.badge = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.badge) {
        let badgeContent = '';
        let badgeClass = '';
        switch (data.badge.type) {
        case 'counter':
            badgeContent = input.find(data.badge.tag).length
            if (data.badge.notice && input.find(data.badge.notice).length) {
                badgeClass = 'field__badge--notice'
                badgeContent = input.find(data.badge.notice).length
            }
            break;
        default:
            break;
        }
        const currentBadge = input.find('> .field__badge');
        if (currentBadge.length > 0) {
            if (badgeContent) currentBadge.removeClass('field__badge--null')
            else currentBadge.addClass('field__badge--null')
            currentBadge.html(badgeContent);
        } else {
            const badge = $('<div class="field__badge ' + badgeClass + ' ' + ((!badgeContent) ? 'field__badge--null' : '') + '">' + badgeContent + '</div>');
            input.append(badge);
        }
    }
    return data
}
